module.exports = __webpack_public_path__ + "img/ppe.08cb2e91.jpg";